
import { MatDialog } from '@angular/material/dialog';
import { MatAccordion } from '@angular/material/expansion';
import { PageEvent, MatPaginator } from '@angular/material/paginator';
import { MatSelect } from '@angular/material/select';
import { MatSort } from '@angular/material/sort';
import { FormGroup, FormBuilder, FormArray } from '@angular/forms';
import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

import { ServicesData } from '../services/services.data';
import { ToraxHttp } from '../utils/custom-http.svc';
import { PeleCardTransactionsData } from './pele-card-transactions.data';

@Component({
	selector: 'pele-card-transactions-list',
	templateUrl: './pele-card-transactions-list.tmpl.html'
})

export class PelecardTransactionsList implements OnInit {

	constructor (
		private PeleCardTransactionsData: PeleCardTransactionsData,
		private formBuilder: FormBuilder,
		public servicesData: ServicesData,
		private router: Router,
		public _matDialog: MatDialog,
		private toraxHttp: ToraxHttp
	) {
	}

	displayedColumns: string[] = ['buttons', 'pelecardTransactionId', 'toraxTermID', 'transactionID', 'debitTotal', 'broadcastDate', 'debitApproveNumber'];
	data: any[] = [];
	resultsLength = 0;
	isRateLimitReached = false;
	searchPeleCardTransactionsListForm: FormGroup;
	sourceList;
	pageRows = 20;
	rowsCount;
	page;

	@ViewChild(MatAccordion, {static: true}) accordion: MatAccordion;
	@ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
	@ViewChild(MatSort, {static: true}) sort: MatSort;
	@Input('payMethodID') public payMethodID?: number;
	@Input('collectionBuilderID') public collectionBuilderID?: number;
	@ViewChild('payMethodGroups') payMethodGroups: MatSelect;




	public clerFilter() {
		this.initForm();
		this.getPeleCardTransactions();
	}
	public getPeleCardTransactions() {
		this.searchPeleCardTransactionsListForm.controls['page'].setValue(this.paginator.pageIndex + 1);

		if (this.payMethodID && this.payMethodID > 0) {
			this.searchPeleCardTransactionsListForm.controls['payMethodID'].setValue(this.payMethodID);
		}
		if (this.collectionBuilderID && this.collectionBuilderID > 0) {
			this.searchPeleCardTransactionsListForm.controls['collectionBuilderID'].setValue(this.collectionBuilderID);
		}

		sessionStorage.setItem(this.router.url, JSON.stringify(this.searchPeleCardTransactionsListForm.value));

		return this.PeleCardTransactionsData!.getList(this.searchPeleCardTransactionsListForm.value)
			.subscribe((data: any) => {
				this.data = data;
				this.sourceList = data.list;
				this.page = data.list.length;
				this.pageRows = data.list.length;
				this.rowsCount = data.rowsCount;
				this.isRateLimitReached = false;
			});
	}

	public changePage(page: number) {
		this.searchPeleCardTransactionsListForm.controls['page'].setValue(page);
		this.getPeleCardTransactions();
	}

	private initForm() {
		this.searchPeleCardTransactionsListForm = this.formBuilder.group({
			page: [1],
			pageRows: [20],
			query: [],
			contactID: [],
			commitmentID: [],
			statusResponses: [null],
			payMethodGroup: [null],
			payMethodID: [null],
			collectionBuilderID: [null],
		});
	}

	ngOnInit() {
		this.initForm();
		if (this.payMethodID == null) {
			let item = sessionStorage.getItem(this.router.url);
			if (item) {
				let frm = JSON.parse(sessionStorage.getItem(this.router.url) || "");
				this.searchPeleCardTransactionsListForm.patchValue(frm);
			}
		}
		this.getPeleCardTransactions();
	}

	selectionChanged(e) {
		this.getPeleCardTransactions();
	}

	pageChange(e) {
		this.searchPeleCardTransactionsListForm.controls['pageRows'].setValue(e.pageSize || 20);
		this.selectionChanged(e);
	}
	sortData(e) {
		this.addOrder(e.active, e.direction != "asc");
		this.getPeleCardTransactions();
	}
	search() {
		this.getPeleCardTransactions();
	}
	addOrder(propertyName: string, desc: boolean = false) {
		const ordersControl = <FormArray>this.searchPeleCardTransactionsListForm.controls['orders'];

		let ord = this.getOrder(propertyName);
		if (ord != null) {
			ord.controls["value"].setValue(desc);
		} else {
			ord = this.initOrder(propertyName, desc);
			ordersControl.push(ord);
		}
	}
	pageEvent: PageEvent;
	pageSizeOptions;
	setPageSizeOptions(setPageSizeOptionsInput: string) {
		this.pageSizeOptions = setPageSizeOptionsInput.split(',').map(str => +str);
	}
	initOrder(propertyName: string, desc: boolean = false) {
		let propName = propertyName;
		let des = desc;
		return this.formBuilder.group({
			key: [propName],
			value: [des],
		});
	}
	getOrder(columnName: string): any {
		let lst = <FormArray>this.searchPeleCardTransactionsListForm.controls['orders'];
		if (lst == null) return null;

		for (var i = 0; i < lst.length; i++) {
			if ((<FormGroup>lst.controls[i]).controls["key"].value == columnName) {
				return lst.controls[i];
			}
		}
		return null;
	}
	orderType(columnName: string) {
		let order = this.getOrder(columnName);
		return order != null ? order.controls["value"].value : null;
	}
}
